import { PageController } from '@client/components/_core/layout/PageController';
import { StringListSetting } from '@client/components/_core/settings/StringListSetting';
import { msprUploadDocumentTypesSetting } from '@shared/schemas/org-settings';
import { createFileRoute } from '@tanstack/react-router';
import { FileText } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/mspr/documents')({
    staticData: {
        metadata: {
            title: 'Documents',
        },
        modules: ['mspr'],
        permissions: ['settings:update'],
        ui: {
            useParentTitle: true,
        },
    },
    component: Documents,
});

function Documents() {
    return (
        <PageController route={Route}>
            <div className="grid grid-cols-1 items-start gap-4 lg:grid-cols-2">
                <StringListSetting
                    definition={msprUploadDocumentTypesSetting}
                    icon={FileText}
                    title="MSP document types"
                    noun="document type"
                    description="The types staff choose from when they upload a document to a material service provider."
                />
            </div>
        </PageController>
    );
}
